import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { useVisualViewport } from "../hooks/useVisualViewport";

// Robust mobile bottom-sheet built on Radix Dialog (NOT vaul). Radix owns the layer stack, so it
// works reliably when nested inside another Dialog/Popover: focus is trapped in THIS (top) layer,
// so tapping the search input actually focuses it and the iOS keyboard opens; taps on options are
// plain clicks (no gesture layer swallowing pointer events). NO AUTOFOCUS: shadcn DialogContent
// already prevents onOpenAutoFocus, so the keyboard only opens after an explicit tap on the field.
// The default centered DialogContent classes are overridden here to anchor it to the bottom.
export function MobileSheet({ open, onOpenChange, title, testId, children }) {
  const vp = useVisualViewport();
  // Anchor the sheet's bottom above the keyboard (vp.keyboard) and cap its height to the visible
  // area, so header + search stay visible and the list scrolls in the remaining space.
  const style = { bottom: vp.keyboard || 0, top: "auto", maxHeight: vp.height ? vp.height - 24 : undefined };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testId}
        style={style}
        className="left-0 right-0 translate-x-0 translate-y-0 w-full max-w-full sm:max-w-full rounded-t-2xl rounded-b-none border-x-0 border-b-0 p-0 gap-0 flex flex-col overflow-hidden data-[state=open]:slide-in-from-bottom data-[state=closed]:slide-out-to-bottom">
        <DialogTitle className="px-4 pt-3 pb-2 pr-10 font-display text-base text-[#1B3B2B] shrink-0">{title}</DialogTitle>
        {children}
      </DialogContent>
    </Dialog>
  );
}
